// Organisation switcher for the account menu (TZ-2 / B7). Shown only to a person of several organisations.
// NomOS sessions are per tenant: switching to an organisation held in this browser activates its session and
// reloads, so no React or module state of the previous one survives. An organisation offered at sign-in but not
// held (or whose session expired) needs the password again: the login page opens with the email filled in and
// goes straight into that organisation once the password is checked (no picker, no slug).
import { Building2, Check, LogIn } from 'lucide-react'
import { DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator } from '@/components/ui/dropdown-menu'
import { isRouted } from '@/services/nomos/switch'
import { activeEmail, beginSignInToAnotherTenant, switchableTenants, switchTenant } from '@/services/nomos/tenant'

/** What the login page needs to finish a switch that requires the password. */
export interface SignInIntent { org: string; name: string; email: string }

export function TenantSwitcherItems({ onLeave }: { onLeave: (intent: SignInIntent) => void }) {
  if (!isRouted('getCurrentUser')) return null
  const tenants = switchableTenants()
  if (tenants.length === 0) return null
  const go = (t: { slug: string; name: string; held: boolean }) => {
    if (t.held && switchTenant(t.slug)) { window.location.assign('/dashboard'); return }
    const email = activeEmail()
    beginSignInToAnotherTenant()
    onLeave({ org: t.slug, name: t.name, email })
  }
  return (
    <>
      <DropdownMenuLabel className="text-xs font-normal text-muted-foreground">Organisation</DropdownMenuLabel>
      {tenants.map((t) => (
        <DropdownMenuItem key={t.slug} disabled={t.active} onClick={() => go(t)} data-testid={`tenant-${t.slug}`}>
          <Building2 className="mr-2 h-4 w-4" />
          <span className="truncate">{t.name}</span>
          {t.active && <Check className="ml-auto h-4 w-4" aria-label="current organisation" />}
          {!t.held && <LogIn className="ml-auto h-3.5 w-3.5 text-muted-foreground" aria-label="sign in required" />}
        </DropdownMenuItem>
      ))}
      <DropdownMenuSeparator />
    </>
  )
}
